import React from 'react'
import styled from 'styled-components'
import { breakpoint, getColor } from '../../shared/theme'
import ContentContainer from '../contentContainer'
import NavigationArrow from '../../elements/navigationArrow'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import prevArrow from '../../assets/images/orange-chevron-left.png'
import nextArrow from '../../assets/images/orange-chevron-right.png'

const SectionWrapper = styled.section`
	padding: 33px 0 24px;
	background-color: ${getColor('greyBg')};

	@media ${breakpoint('tablet')} {
		padding: 82px 0;
	}

	@media ${breakpoint('laptop')} {
		padding: 117px 0;
	}
`

const TestimonialWrapper = styled.div`
	margin-top: 6px;
	display: flex;
	flex-direction: column;
	align-items: center;

	@media ${breakpoint('tablet')} {
		margin-top: 0px;
		align-items: flex-end;
	}
`

const TestmonialText = styled.p`
	margin-bottom: 24px;
	text-align: center;
	font-size: 20.75px;
	line-height: 24.9px;
	font-weight: 700;

	@media ${breakpoint('tablet')} {
		margin-bottom: 50px;
		text-align: left;
		font-size: 45px;
		line-height: 54px;
	}
`

const TestimonialName = styled.span`
	text-align: center;
	font-size: 13.8px;
	line-height: 16.5px;
	font-weight: 700;
	float: right;
	color: ${getColor('orange')};

	@media ${breakpoint('tablet')} {
		text-align: right;
		font-size: 30px;
		line-height: 36px;
	}
`

const NextArrow = (props) => {
	const { className, style, onClick } = props
	return (
		<NavigationArrow
			className={className}
			style={{ ...style }}
			onClick={onClick}
			src={nextArrow}
			left={false}
		/>
	)
}

const PrevArrow = (props) => {
	const { className, style, onClick } = props
	return (
		<NavigationArrow
			className={className}
			style={{ ...style }}
			onClick={onClick}
			src={prevArrow}
			left={true}
		/>
	)
}

const slickSettings = {
	infinite: true,
	autoplay: false,
	autoplaySpeed: 5000,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	swipeToSlide: true,
	initialSlide: 0,
	nextArrow: <NextArrow />,
	prevArrow: <PrevArrow />,
}

export const Testimonial = ({ testimonials }) => {
	return (
		<SectionWrapper>
			<ContentContainer>
				<Slider {...slickSettings}>
					{testimonials &&
						testimonials.map((testimonial, index) => {
							return (
								<TestimonialWrapper key={index}>
									<TestmonialText>
										{testimonial.testimonialText && testimonial.testimonialText}
									</TestmonialText>
									<TestimonialName>
										{testimonial.testimonialName && testimonial.testimonialName}
										,{' '}
										{testimonial.testimonialCompany &&
											testimonial.testimonialCompany}
									</TestimonialName>
								</TestimonialWrapper>
							)
						})}
				</Slider>
			</ContentContainer>
		</SectionWrapper>
	)
}

export default Testimonial
